//
//
//
//
import * as echarts from 'echarts';
import { getAction } from '@/api/manage';
export default {
  props: {
    width: {
      type: String,
      default: '350px'
    },
    height: {
      type: String,
      default: '250px'
    },
    top: {
      type: String,
      default: '10px'
    },
    left: {
      type: String,
      default: '0'
    }
  },
  data: function data() {
    return {
      chart: null,
      myChart: null
    };
  },
  methods: {
    initBarChart: function initBarChart(popArr, time, labelData) {
      var _this = this;

      //	得到仪表盘
      var arrs = [];

      for (var i = 0; i < popArr.length; i++) {
        arrs.push({
          name: popArr[i].title,
          type: 'line',
          symbol: 'circle',
          showSymbol: false,
          symbolSize: 8,
          // stack: 'Total',
          itemStyle: {
            normal: {
              // color: '#0092f6',
              // lineStyle: {
              //   color: '#0092f6',
              //   width: 1,
              // },
              areaStyle: {//color: '#94C9EC'
                // color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                //   {
                //     offset: 0.4,
                //     color: 'rgba(7,44,90,0.1)',
                //   },
                //   {
                //     offset: 1,
                //     color: 'rgba(0,146,246,0.9)',
                //   },
                // ]),
              }
            }
          },
          // markPoint: {
          //   itemStyle: {
          //     normal: {
          //       color: 'red',
          //     },
          //   },
          // },
          data: popArr[i].data
        });
      }

      this.option = {
        // backgroundColor: '#11183c',
        grid: {
          left: '5%',
          right: '7%',
          top: '15%',
          bottom: '25%',
          containLabel: true
        },
        color: ['#fbceb2', '#dbb0e3'],
        legend: {
          // show:labelData?true:false,
          data: labelData ? labelData : [],
          itemWidth: 20,
          itemHeight: 10,
          textStyle: {
            fontSize: 14,
            color: '#65aaf1'
          },
          // right: '0', //距离右侧
          top: '0%',
          left: '5%',
          lineHeight: '20'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
            lineStyle: {
              color: '#57617B'
            }
          }
        },
        xAxis: [{
          type: 'category',
          boundaryGap: false,
          axisLabel: {
            color: '#65aaf1'
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#0a2b52',
              width: 1
            }
          },

          /*axisTick:{
           	show:false,
           },
           splitLine:{
           	show:true,
            lineStyle:{
            	color:'#195384'
            }
          },*/
          data: time
        }],
        yAxis: [{
          type: 'value',
          axisLabel: {
            color: '#65aaf1' //刻度线标签颜色

          },
          splitLine: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#65aaf1'
            }
          }
        }],
        series: arrs
      };
      this.chart = this.$refs.chart11;
      this.myChart = this.$echarts.init(this.chart);
      this.myChart.setOption(this.option);
      window.addEventListener('resize', function () {
        _this.myChart.resize();
      });
    }
  }
};